<template>
  <div class="content">
    <div class="container" v-show="!showShopOrderDetail">
      <SelectChannel @selectChannel="handleSelectChannel"/>
      <div class="right-container">
        <div class="list-container" :style="{height: height}">
          <div class="header">渠道运效记录</div>
          <div class="toolbar">
            <el-input placeholder="查询关键字" v-model="keyword" :clearable="true" :style="{ width:'250px',marginTop: '15px',float: 'right'}">
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
          </div>
          <el-table :data="ordFreightAnalyseChannelList"
                    highlight-current-row
                    ref="table"
                    v-loading="loading"
                    @sort-change="handleSortChange">
            <el-table-column label="序号" type="index" align="center" width="60px" :index="getIndex"></el-table-column>
            <el-table-column label="订单渠道" align="left" width="100px" prop="sChannel" sortable="custom"></el-table-column>
            <el-table-column label="店铺ID" align="center" width="120px" prop="rShop" sortable="custom"></el-table-column>
            <el-table-column label="店铺名称" align="left" width="300px" prop="sShop" sortable="custom"></el-table-column>
            <el-table-column label="订单量" align="left" width="100px" prop="totalReceive" sortable="custom"></el-table-column>
            <el-table-column label="配送量" align="left" width="100px" prop="totalDelivery" sortable="custom"></el-table-column>
            <el-table-column label="运费总计" align="left" width="100px" prop="totalCost" :formatter="priceFormatter" sortable="custom"></el-table-column>
            <el-table-column label="平均距离" align="left" width="120px" prop="avgDistance" sortable="custom"></el-table-column>
            <el-table-column label="平均时长" align="left" width="120px" prop="avgDeliveryTime" :formatter="timeFormatter" sortable="custom"></el-table-column>
            <el-table-column label="平均运费" align="left" width="100px" prop="avgDeliveryCost" :formatter="priceFormatter" sortable="custom"></el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="view(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :layout="pageLayout"
            :total="total"
            :current-page="pageNum"
            :page-sizes="pageSelect"
            :page-size="pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :style="{marginTop: '15px'}">
          </el-pagination>
        </div>
      </div>
    </div>
    <ShopOrderDetail v-if="showShopOrderDetail" @close="handleCloseDetail" :shopData="shopData"/>
  </div>
</template>

<script>
import {getOrdFreightAnalyseChannelList} from "@/api/delivery/delivery";
import {freightTypeMap,freightStatusMap} from "@/utils/deliveryMap";
import {formatTime,formatSeconds} from "@/utils/utils";
import SelectChannel from "@/views/components/SelectChannel";
import ShopOrderDetail from "@/views/components/DeliveryEffiRider/ShopOrderDetail";

export default {
  name: "deliveryEffiChannel",
  components: {SelectChannel,ShopOrderDetail},
  data() {
    return {
      height: document.documentElement.clientHeight - 60 + "px",
      rChannel:'',
      shopData:null,
      keyword:'',
      ordFreightAnalyseChannelList:[],
      loading:false,
      total: 0, //总条数
      pageNum: 1, //当前页
      pageSize: 10, //每页显示条数
      pageSelect: [10, 20, 30, 50],
      pageLayout:"prev, pager, next,jumper,total,sizes",
      showShopOrderDetail:false,
      orderByColumn:'',
      isAsc:'',
    };
  },
  created() {
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  computed: {
    getFreightType() {
      return function(bType) {
        return freightTypeMap[bType] || '未知';
      };
    },
    getFreightStatus() {
      return function(bType) {
        return freightStatusMap[bType] || '未知';
      };
    },
  },
  methods: {
    getOrdFreightAnalyseChannelList() {
      let params = {
        search:this.keyword,
        rChannel:this.rChannel === 'all'?'':this.rChannel,
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        orderByColumn: this.orderByColumn,
        isAsc: this.isAsc,
      }
      this.loading = true;
      getOrdFreightAnalyseChannelList(params).then(result => {
        if (result) {
          this.ordFreightAnalyseChannelList = result.rows;
          this.total = result.total;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSortChange({ prop, order }) {
      if (order) {
        this.orderByColumn = prop;
        this.isAsc = order === 'ascending' ? 'asc' : 'desc';
        this.getOrdFreightAnalyseChannelList();
      }else{
        this.orderByColumn = '';
        this.isAsc = '';
        this.getOrdFreightAnalyseChannelList();
      }
    },
    // 查询
    search(){
      this.pageNum = 1;
      this.getOrdFreightAnalyseChannelList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getOrdFreightAnalyseChannelList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getOrdFreightAnalyseChannelList();
    },
    handleSelectChannel(e) {
      this.rChannel = e;
      this.pageNum = 1;
      this.getOrdFreightAnalyseChannelList();
    },
    handleCloseDetail(){
      this.showShopOrderDetail = false;
    },
    view(item){
      this.shopData = {sid:item.rShop,cname:item.sShop};
      this.showShopOrderDetail = true;
    },
    getIndex(rowIndex) {
      return (this.pageNum - 1) * this.pageSize + rowIndex +1;
    },
    priceFormatter(row, column, cellValue) {
      return cellValue?'￥'+cellValue:'';
    },
    timeFormatter(row, column, cellValue) {
      return formatSeconds(cellValue);
    },
    dateFormatter(row, column, cellValue) {
      return cellValue?formatTime(cellValue,"YYYY-MM-DD HH:mm"):'';
    },
    handleKeydown(event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        this.pageNum = 1;
        this.getOrdFreightAnalyseChannelList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content{
  width: 100%;
  height: 100%;
}
.container{
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
}
.right-container{
  float:left;
  width:calc(100% - 240px);
  height: 100%;
}
.list-container{
  width: 100%;
  border: 1px solid #ddd;
  padding: 0px 20px;
  .header{
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    padding-left: 5px;
    border-bottom: 1px solid #ddd;
  }
  .toolbar{
    width: 100%;
    height: 60px;
  }
}
</style>
